import { useCallback, useMemo, useSyncExternalStore } from "react";
import { getGoogleText, subscribeGoogleText } from "./googleText";

export function useGoogleText(sources: readonly string[]) {
  const key = JSON.stringify([...new Set(sources)].sort());
  const subscribe = useCallback(
    (listener: () => void) =>
      subscribeGoogleText(JSON.parse(key) as string[], listener),
    [key],
  );
  const snapshot = useCallback(
    () => (JSON.parse(key) as string[]).map(getGoogleText).join("\u0000"),
    [key],
  );
  const value = useSyncExternalStore(subscribe, snapshot, snapshot);
  return useMemo(() => {
    const strings = JSON.parse(key) as string[];
    const values = value.split("\u0000");
    const translated = new Map(strings.map((source, i) => [source, values[i]]));
    return (source: string): string => translated.get(source) || source;
  }, [key, value]);
}
